// store/slices/feedbackSlice.ts
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { feedbackApi } from "../../services/feedbackApi";
import type { FeedbackState, FeedbackSubmission } from "../types/feedbackTypes";

const initialState: FeedbackState = {
    message: "",
    isSubmitting: false,
    isSubmitted: false,
    error: null
};

export const submitFeedbackForm = createAsyncThunk("feedback/submit", async (payload: FeedbackSubmission, { rejectWithValue }) => {
    try {
        return await feedbackApi.submitFeedback(payload);
    } catch (error) {
        return rejectWithValue(error instanceof Error ? error.message : "Unknown error");
    }
});

const feedbackSlice = createSlice({
    name: "feedback",
    initialState,
    reducers: {
        setFeedbackMessage: (state, action: PayloadAction<string>) => {
            state.message = action.payload;
        },
        resetFeedback: () => initialState,
        clearFeedbackError: state => {
            state.error = null;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(submitFeedbackForm.pending, state => {
                state.isSubmitting = true;
                state.error = null;
            })
            .addCase(submitFeedbackForm.fulfilled, state => {
                state.isSubmitting = false;
                state.isSubmitted = true;
                state.message = "";
            })
            .addCase(submitFeedbackForm.rejected, (state, action) => {
                state.isSubmitting = false;
                state.error = action.payload as string;
            });
    }
});

export const { setFeedbackMessage, resetFeedback, clearFeedbackError } = feedbackSlice.actions;
export default feedbackSlice.reducer;
